/*
 * Copyright (c) 2025-2026.  atagon GmbH.  All rights reserved.
 *
 * This file is part of the atagon codebase and may not be copied,
 *  distributed, or modified without explicit written permission from
 * atagon GmbH. https://www.atagon.com
 */

import {callWSFunction} from "../APIClient.jsx";
import {UI} from "../UIGenerator.jsx";
import {Util} from "../Utilities.js";
import {names} from "../Constants.js";

const Pages = function (pageId) {


    async function create(containerName, imageIndexKey, exposedPorts, httpPort, nodeId) {


    }

    async function removeDialog(querySelector) {
        let pageInfo = await getInfo()

        UI.miniDialog(Util.unique.newInternalId(), (inputState, setState, close) => <>
            <p className={"p-3"}>
                Are you sure you want to delete
                the {names.page} "<span className={"font-bold"}>{pageInfo.domain}</span>" permanently?
            </p>


        </>, (info, close) => {
            close()
        }, {
            querySelector: querySelector,
            button: [{
                type: "auto",
                text: "Yes delete",
                onClick: async (state, setState, close) => {
                    await remove()
                    close()
                },
            }, {
                type: "auto",
                text: "No Keep",
                onClick: (state, setState, close) => {
                    close()
                },

            }]


        }).open()
    }


    async function remove() {
        return callWSFunction("pages.remove", {
            pageId: pageId,
        })
    }

    async function getInfo() {
        return callWSFunction("pages.getInfo", {
            pageId: pageId,
        })
    }

    async function doesExist() {

    }

    function getLogs() {

    }

    function update(values) {
        return callWSFunction("pages.update", {
            pageId: pageId,
            values: values
        })
    }


    return {create, remove, getInfo, getLogs, doesExist, update, removeDialog}
}

export {Pages}